<!-- <div class="container">

  <app-header></app-header>
  <div>
    <label for="circleSelect">Select Language:</label>
      <select class="form-select"  [(ngModel)]="languageSelect" id="languageSelect">
                                <option value="eng">English</option>
                                <option value="pan">Panjabi</option>
                            </select>
  </div>
  <div class="upload-section">
    <h2>Upload an Image</h2>
        <input class="form-control" type="file" (change)="onFileChoose($event)" />
    <app-dropzone (fileSelected)="onFileSelected($event)"></app-dropzone>
  </div>


  <div class="result-section" *ngIf="extractedText">
    <h2>Extracted Text</h2>
    <textarea rows="10" cols="50" [(ngModel)]="extractedText" readonly></textarea>
  </div>

  <div class="search-section">
    <h2>Search Text</h2>
    <input type="text" [(ngModel)]="searchText" placeholder="Enter text to search" />
    <button (click)="search()">Search</button>
    <p>{{ searchResult }}</p>
  </div>

  <div *ngIf="loading" class="loading-indicator">
    <p>Loading... Please wait.</p>
  </div>
</div> -->

<!-- <div class="container">

  <app-header></app-header>

  <div class="section card">
    <label for="languageSelect" class="section-title">Select Language</label>
    <select class="form-select modern-select" [(ngModel)]="languageSelect" id="languageSelect">
      <option value="eng">English</option>
      <option value="pan">Panjabi</option>
    </select>
  </div>


  <div class="section card">
    <h2 class="section-title">Upload an Image</h2>
    <input
      class="form-control file-input"
      type="file"
      (change)="onFileChoose($event)"
    />
    <app-dropzone (fileSelected)="onFileSelected($event)"></app-dropzone>
  </div>

 
  <div class="section card" *ngIf="extractedText">
    <h2 class="section-title">Extracted Text</h2>
    <textarea
      class="extracted-text"
      rows="10"
      [(ngModel)]="extractedText"
      readonly
    ></textarea>
  </div>
 <div class="section card">
    <h2 class="section-title">Search Text</h2>
    <div class="search-row">
      <input
        type="text"
        class="search-input"
        [(ngModel)]="searchText"
        placeholder="Enter text to search..."
      />
      <button class="btn-primary" (click)="search()">Search</button>
    </div>
    <p class="search-result">{{ searchResult }}</p>
  </div>

 
  <div *ngIf="loading" class="loading-overlay">
    <div class="spinner"></div>
    <p>Processing... Please wait.</p>
  </div>
</div> -->


<div class="container">

  <!-- <app-header></app-header> -->

  <div class="grid-layout">

    <!-- LEFT SIDE -->
    <div class="left-side">

      <!-- Language Selector -->
      <div class="section card">
        <label for="languageSelect" class="section-title">Select Language</label>
        <select class="form-select modern-select" [(ngModel)]="languageSelect" id="languageSelect" (change)="lanChange()">
          <option value="eng">English</option>
          <option value="pan">Panjabi</option>
          <option value="hin">Hindi</option>
                    <option value="eng+pan">English + Panjabi</option>
          <option value="eng+pan+hin">English + Punjabi + Hindi</option>
          <option value="eng+hin">English + Hindi</option>

        </select> 
        <button class="btn-primary mt-2" (click)="reset()">clear</button>
      </div>

      <!-- Upload Section -->
      <div class="section card">
        <h2 class="section-title">Upload an Image</h2>
        <input
          class="form-control file-input"
          type="file"
          (change)="onFileChoose($event)"
        />
        <app-dropzone (fileSelected)="onFileSelected($event)"></app-dropzone>
      </div>

    </div>

    <!-- RIGHT SIDE -->
    <div class="right-side">

       <!-- Search Section -->
      <div class="section card"  *ngIf="extractedText">
        <h2 class="section-title">Search Text</h2>
        <div class="search-row">
          <input
            type="text"
            class="search-input"
            [(ngModel)]="searchText"
            placeholder="Enter text to search..."
          />
          <button class="btn-primary" (click)="search()">Search</button>
        </div>
        <p class="search-result">{{ searchResult }}</p>
      </div>
      <!-- Extracted Text Section -->
      <div class="section card" *ngIf="extractedText">
        <h2 class="section-title">Extracted Text</h2>
        <textarea
          class="extracted-text"
          rows="10"
          [(ngModel)]="extractedText"
          readonly
        ></textarea>
      </div>

     

    </div>

  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="loading-overlay">
    <div class="spinner"></div>
    <p>Processing... Please wait.</p>
  </div>

</div>
